<template>
    <section class="question">
        <question-tag
            :correctRate="question.correctRate"
            :avgSolveTime="question.avgSolveTime"
            :level="paperLevel"
        ></question-tag>

        <!-- {{solveTime}}
        
        {{setedAnswer}} -->
    <div class="">
        <div class="single pdl-16 pdr-16" v-if="groupQuestionCount === 1">
            <div class="t-subtitle5 question-title ">
                {{ question.contents.text }}
                <img :src="question.contents.image" alt="" v-if="question.contents.image" class="mgt-16 independent-img-video-bd-radius">
            </div>
            <div class="question-choices essay mgt-16">
           
                <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`answerEl`">
                    <textarea id="textarea" class="mdc-text-field__input" 
                        rows="5"
                        v-model="textAnswer"
                        readonly
                    ></textarea>
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                            
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>

                <hr class="divider mtb-1">

                <div class="mdc-card mdc-elevation--z3 my-degree-card mgt-16 mgb-16">
                    <div class="correct-rate d-flex pda-default justify-content-between align-items-baseline">
                        <div class="t-body2">
                            {{$t('1276')}}
                            <!-- 채점 결과 -->
                        </div>
                        <div class="t-body3">
                            {{$t('1277')}}
                            <!-- 정답률  -->
                            <span class="t-headline9">
                                {{question.essay.partialScore}} %
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="question.essay.essentialWordList.length > 0">
                    <div class="t-body2 mgb-8">
                        {{$t('1278')}}
                        <!-- 필수 포함되어야 할 단어 -->
                    </div>
                    <div class="t-body2">
                        <div class="t-body1 choice">
                            <div class="choice-text">
                                <div class="text essential-word pdt-6 pdb-6 pdl-16 pdr-16 t-color-quizBlack">
                                    <span v-for="(word, index) in question.essay.essentialWordList" :key="index">
                                        {{word}}{{question.essay.essentialWordList.length > index+1 ? ', ' : ''}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>
                
            </div> 

            
        </div>

        <div class="group" v-else>
            <div class="bottom-card1">
                <div class="mdc-card mdc-elevation--z2 my-degree-card question-group bottom-card1-1"></div>
            </div>
            <div class="bottom-card2">
                <div class="mdc-card mdc-elevation--z1 my-degree-card question-group bottom-card2-1"></div>
            </div>
            
            <div class="t-subtitle5 question-title">
                {{groupQuestionTitle}}
            </div>

            <div class="mdc-card mdc-elevation--z3 my-degree-card question-group">
                <div class="t-headline14 question-title " >
                    {{question.contents.text}}
                    <img :src="question.contents.image" alt="" v-if="question.contents.image" class="independent-img-video-bd-radius" >
                </div>
                <div class="question-choices essay">
                    <!-- <div class="t-body2">
                        {{isCorrect() ? $t('1270') : $t('1271')}}
                    </div> -->

                    <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`answerEl`">
                        <textarea id="textarea" class="mdc-text-field__input" 
                            rows="5"
                            v-model="textAnswer"
                            readonly
                        ></textarea>
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                                
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>

                    <hr class="divider mtb-1">

                    <div class="mdc-card mdc-elevation--z3 my-degree-card">
                        <div class="correct-rate">
                            <div class="t-body2">
                                {{$t('1276')}}
                                <!-- 채점 결과 -->
                            </div>
                            <div class="t-body3">
                                {{$t('1277')}}
                                <!-- 정답률  -->
                                <span class="t-headline9">
                                    {{question.essay.partialScore}} %
                                </span>
                            </div>
                        </div>
                    </div>

                    <div v-if="question.essay.essentialWordList.length > 0">
                        <div class="t-body2 mt-1">
                            {{$t('1278')}}
                            <!-- 필수 포함되어야 할 단어 -->
                        </div>
                        <div class="t-body2">
                            <div class="t-body1 choice">
                                <div class="choice-text">
                                    <div class="text essential-word">
                                        <span v-for="(word, index) in question.essay.essentialWordList" :key="index">
                                            {{word}}{{question.essay.essentialWordList.length > index+1 ? ', ' : ''}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                    </div>
                    
                </div> 
            </div>

        </div>
        

        <div class="h-1"></div>
        
        
        <div class="pdl-16 pdr-16 mgb-16" v-if="question">
            <question-tip v-if="question.tip" :tip="question.tip"/>
        </div>
         

        <question-feedback
            :commonFeedback="question.feedback.common"
            :correctFeedback="question.feedback.correct"
            :incorrectFeedback="question.feedback.incorrect"
            :videoFeedback="question.feedback.video"
            :feedbackStatus="feedback"
            :correct="question.correct"
            :questionId="question.questionId"
        ></question-feedback>
        </div>
    </section>
    
</template>

<script>
/**
 * 에세이 문항 피드백 컴포넌트(essay type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
    props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback'],
    data() {
        return {
            textAnswer: '',
            textCorrect: ''
        }
    },
    components: {
        'question-tag': QuestionTag,
        'question-tip': QuestionTip,
        'question-feedback': QuestionFeedback
    },

    mixins: [questionMixin],

    mounted() {
        this.textAnswer = this.question.textAnswer
        this.textCorrect = this.question.textCorrect
        const textField = new MDCTextField(document.getElementById(`answerEl`))
    },
}
</script>
